import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function OpeningHook() {
  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-24 px-4 bg-night-800/30" data-id="element-125">
      <div className="max-w-3xl mx-auto" data-id="element-126">
        <FadeIn data-id="element-127">
          <div className="border-l-4 border-amber-500 pl-6 md:pl-10 py-2" data-id="element-128">
            <p className="font-serif text-xl md:text-2xl lg:text-3xl italic leading-relaxed text-cream/90" data-id="element-129">
              It's 3:15 AM. You are awake again. Your heart is racing, your neck
              is damp with sweat, and your brain is already calculating how many
              hours of "mush" you'll have to survive tomorrow.
            </p>
            <p className="font-serif text-xl md:text-2xl lg:text-3xl italic leading-relaxed text-cream/90 mt-6" data-id="element-130">
              You've tried the lavender sprays. You've tried the cooling
              pillows. You've even tried "just relaxing." But your body feels
              like a furnace, and your mind won't stop spinning.
            </p>
            <p className="font-serif text-xl md:text-2xl lg:text-3xl italic leading-relaxed text-amber-400 mt-6 font-medium" data-id="element-131">
              This isn't stress—it's a biological glitch. And you can't
              "meditate" your way out of a hormonal temperature spike.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} className="mt-12 flex justify-center" data-id="element-132">
          <Button onClick={scrollToCTA} data-id="element-133">Stop The 3 AM Spin Cycle</Button>
        </FadeIn>
      </div>
    </section>;
}